function init_abo_modal() {
    var modal = $('.abo-modal');
    var button = $('button[data-id="modal"]');

    $(document).on('click', function (event) {
       if($(event.target).is(modal)) {
           $(modal).hide();
       }
    });

    button.on( 'click', function () {
        modal.show();
    });

    $('.abo-modal-close' ).on('click', function () {
        modal.hide();
    });
}

if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", init_abo_modal, false);
} else {
    window.onload = function () {
        init_abo_modal();
    };
}